var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgECommerceSolutions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 502.707 502.707",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D44A00"
    },
    d: "M474.978,85.787c-3.128-8.24-12.339-12.403-20.557-9.275l-83.673,31.558 c-4.616,1.769-8.132,5.479-9.599,10.203l-61.002,195.582c-41.265,0-181.281,0-199.594,0 c-5.738-19.888-42.538-148.019-42.538-148.019c-2.502-8.499-11.303-13.374-19.759-10.958c-8.477,2.438-13.374,11.26-10.936,19.78 l45.859,159.538c1.963,6.838,8.218,11.583,15.315,11.583h202.14c-4.357,15.056-9.966,34.405-12.705,43.789 c-21.204,0-191.419,0-191.419,0c-8.801,0-15.941,7.14-15.941,15.984s7.14,15.919,15.941,15.919h203.391 c7.118,0,13.374-4.659,15.38-11.476l21.938-75.778c0-0.022,0-0.043,0-0.065c1.208-3.84,57.788-185.315,62.059-198.969 c12.144-4.573,76.404-28.84,76.404-28.84c6.363-2.437,10.332-8.52,10.332-14.905C475.992,89.583,475.647,87.642,474.978,85.787z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D44A00"
    },
    cx: 287.161,
    cy: 467.439,
    r: 35.268
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D44A00"
    },
    cx: 94.987,
    cy: 467.439,
    r: 35.268
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D44A00"
    },
    d: "M139.099,192.002h122.263c26.963-19.155,44.716-50.497,44.716-86.132 C306.122,47.369,258.688,0,200.188,0C141.731,0,94.34,47.348,94.34,105.848C94.34,141.504,112.093,172.847,139.099,192.002z  M200.188,92.107c6.148,0,11.152,18.4,11.152,41.049s-5.004,41.049-11.152,41.049c-6.191,0-11.087-18.421-11.087-41.071 C189.1,110.486,194.019,92.107,200.188,92.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D44A00"
    },
    d: "M168.069,279.342c3.775,8.952,16.437,15.725,32.14,15.725c15.747,0,28.322-6.773,32.119-15.725 h28.732v-74.915H139.423v74.937h28.646C168.069,279.363,168.069,279.342,168.069,279.342z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerceSolutions);
export default __webpack_public_path__ + "static/media/e-commerce-solutions.4e27b0c4b5145bea01c4b7f037c1e007.svg";
export { ForwardRef as ReactComponent };